import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"
import * as _date from "date-fns"
// -- import * as _ from "lodash-es"

const content_type = "sPlant_OrderForecast"

const create = function () { }

const fields = {
  default: [
    {
      key: "AccountNum",
      label: "客户编码",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "ItemId",
      label: "SEI物料编号",
      sortable: true
    },
    {
      key: "ModelId",
      label: "预测模型",
      sortable: true
    },
    {
      key: "StartDate",
      label: "需求日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      type: "number"
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",
      sortable: true
    },
    {
      key: "SEI_ForecastAccuracy",
      label: "预测准确率",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_OtherInfo",
      label: "其他信息",
      sortable: true
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      sortable: true
    }
  ]
}

const dataForm = {
  id: ""
}

///前端验证
const rules = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  {}
)
const methods = {
  async SaveSalesForcastExport(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "generate_salesforcast",
      {},
      {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(_params) {
    let _actions = []
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_seq",
      {},
      {}
    )
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Line",
      {},
      {}
    )
    _.each(_params.mt, t => {
      //获取code
      let _p = {
        type: "CFC",
        date: _date.format(new Date(), "yyyy-MM-dd")
      }
      let _new = _.cloneDeep(t)
      delete _new.id
      _actions.push(
        code_biz_data
          .execAction({
            params: _p,
            fields: ["seq"]
          })
          .action({
            output_last_item_map: {
              seq: "ForecastSalesId"
            }
          })
      )
      _actions.push(
        biz_data
          .insertAction({
            params: _new,
            fields: ["id"]
          })
          .action({
            mixin_last_item_map: {
              ForecastSalesId: "ForecastSalesId"
            },
            output_last_item_map: {
              id: "order_forecast_id"
            },
            output_last_item_when_no_data: {
              order_forecast_id: -1
            }
          })
      )
      let _items = _.filter(_params.lt, {
        CustAccountId: t.CustAccountId
      })
      if (_items && _items.length > 0) {
        let _seq = 1
        _.each(_items, m => {
          let _item_new = _.cloneDeep(m)
          _item_new.seq = _seq
          delete _item_new.id
          delete _item_new.CustAccountId
          _actions.push(
            item_biz_data
              .insertAction({
                params: _item_new,
                fields: ["id"]
              })
              .action({
                mixin_last_item_map: {
                  order_forecast_id: "order_forecast_id",
                  ForecastSalesId: "ForecastSalesId"
                },
                output_last_item_map: {
                  id: "id"
                },
                output_last_item_when_no_data: {
                  id: -1
                },
                rollback_when: {
                  order_forecast_id: {
                    "=": -1
                  },
                  id: {
                    "=": -1
                  }
                }
              })
          )
          _seq += 1
        })
      }
    })
    let result = await api.query_batch({
      actions: _actions
    })


    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _rt = result.data.BatchResult.Actions
      if (
        _rt[_rt.length - 1] &&
        !_.isNull(_rt[_rt.length - 1].Result.Data) &&
        !_.isNull(_rt[_rt.length - 1].Result.Data[0])
      ) {
        return result.data.BatchResult.Actions
      }
      return null
    } else {
      return null
    }
  }
}
export { fields, methods, dataForm }
